import { StateCreator } from 'zustand';
import {
  HistoryConversationsSlice,
  HistoryConversationsSliceState,
} from './index.types';

const initialState: HistoryConversationsSliceState = {
  historyConversations: [],
  historyFetchParams: undefined,
};

export const createHistorySlice: StateCreator<HistoryConversationsSlice> = (
  set
) => ({
  ...initialState,
  updateHistoryConversations: (historyConversations) => {
    set({ historyConversations });
  },
  updateHistoryFetchParams: (conversationCurrentDate, conversationSubDate) => {
    set({
      historyFetchParams: { conversationCurrentDate, conversationSubDate },
    });
  },
});
